import axios, { AxiosError } from "axios";
import { BASE_API, NOT_CONNECTED_MESSAGE } from "../utils/constants";

export const GET = async <R>(
    url: string,
    params: any = {},
    headers: any = {}
): Promise<R> => {
    try {
        const response = await axios.get(BASE_API + url, {
            withCredentials: true,
            params,
            headers: {
                ...headers,
                "x-master-key": process.env.REACT_APP_MASTER_KEY,
            },

            // headers: { "x-intent": intent },
        });
        return [response.data, null] as any;
    } catch (err: any) {
        return [
            null,
            err.response?.data?.message || NOT_CONNECTED_MESSAGE,
        ] as any;
    }
};

export const POST = async <R>(
    url: string,
    data = {},
    params = {},
    headers = {}
): Promise<R> => {
    try {
        const response = await axios.post(BASE_API + url, data, {
            withCredentials: true,
            params,
            headers: {
                ...headers,
                "x-master-key": process.env.REACT_APP_MASTER_KEY,
            },
        });

        console.log(response);

        return [response.data, null] as any;
    } catch (err) {
        console.log(err);

        return [
            null,
            (err as AxiosError).response?.data ?? {
                message: NOT_CONNECTED_MESSAGE,
            },
        ] as any;
    }
};

export const PATCH = async <R>(
    url: string,
    data: any = null,
    params = {},
    headers = {}
) => {
    try {
        console.log({ data });
        const response = await axios.patch(BASE_API + url, data, {
            withCredentials: true,
            params,
            headers: {
                ...headers,
                "x-master-key": process.env.REACT_APP_MASTER_KEY,
            },
        });
        return [response.data, null] as any;
    } catch (err) {
        return [
            null,
            (err as AxiosError).response?.data || NOT_CONNECTED_MESSAGE,
        ] as any;
    }
};

export const DELETE = async <R>(
    url: string,
    id: string,
    params = {},
    headers = {}
): Promise<R> => {
    try {
        const response = await axios.delete(BASE_API + url, {
            withCredentials: true,
            params: { id, ...params },
            headers: {
                ...headers,
                "x-master-key": process.env.REACT_APP_MASTER_KEY,
            },
        });
        return [response.data, null] as any;
    } catch (err) {
        return [
            null,
            (err as AxiosError).response?.data || NOT_CONNECTED_MESSAGE,
        ] as any;
    }
};

export type Api_Response<D, E = { success: false; message: string }> =
    | [D, null]
    | [null, E];

export interface IBase_Entity {
    createdAt: string;
    updatedAt: string;
    deletedAt: null | string;
}

export type Base_Filter = { page: number; limit: number; search?: string };
